<div class="nav-container">
  <div class="logo-container">
    <img
      class="logo"
      src="../assets/svg/QS_New_Logo_Black.svg"
      alt="dashboard - Quantum Systems"
    />
  </div>

  <div
    class="menu-container"
    data-testid="primary-nav"
    *ngIf="profile$ | async as profile"
  >
    <ng-container *ngFor="let menu of menuItems">
      @if (menu.hasFeature$ | async) {
        @if (!menu.roles || menu.roles.includes(profile.role)) {
          @if (menu.children?.length) {
            <div class="menu-group">
              <div
                class="menu-item menu-group-label"
                [attr.data-testid]="'nav-item-' + menu.id"
                [ngClass]="menu.isActive(url) ? 'active' : ''"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="isMenuExpanded(menu)"
                (click)="toggleMenu(menu)"
                (keydown)="onMenuGroupKeydown($event, menu)"
              >
                <div class="menu-group-title">
                  <img class="icon" [src]="menu.icon" [alt]="menu.alt" />
                  <div>{{ 'side_nav.menu.' + menu.id | translate }}</div>
                </div>
                <mat-icon
                  class="menu-expand-icon"
                  [ngClass]="{ expanded: isMenuExpanded(menu) }"
                >
                  chevron_right
                </mat-icon>
              </div>
              @if (isMenuExpanded(menu)) {
                <ng-container *ngFor="let childMenu of menu.children">
                  @if (childMenu.hasFeature$ | async) {
                    @if (
                      !childMenu.roles || childMenu.roles.includes(profile.role)
                    ) {
                      <a
                        class="menu-item child-menu-item"
                        [attr.data-testid]="'nav-child-' + childMenu.id"
                        [ngClass]="childMenu.isActive(url) ? 'active' : ''"
                        [routerLink]="childMenu.link"
                      >
                        <img
                          class="icon"
                          [src]="childMenu.icon"
                          [alt]="childMenu.alt"
                        />
                        <div>
                          {{ 'side_nav.menu.' + childMenu.id | translate }}
                        </div>
                      </a>
                    }
                  }
                </ng-container>
              }
            </div>
          } @else {
            <a
              class="menu-item"
              [attr.data-testid]="'nav-item-' + menu.id"
              [ngClass]="menu.isActive(url) ? 'active' : ''"
              [routerLink]="menu.link"
            >
              <img class="icon" [src]="menu.icon" [alt]="menu.alt" />
              <div>{{ 'side_nav.menu.' + menu.id | translate }}</div>
            </a>
          }
        }
      }
    </ng-container>
  </div>
  <div class="profile-menu-container">
    <div class="line"></div>
    <a
      class="menu-item"
      data-testid="nav-profile"
      [ngClass]="{ active: url.startsWith('/profile') }"
      routerLink="/profile"
    >
      <app-avatar [avatarTop]="true"></app-avatar>
    </a>
  </div>
  <div class="legal-container">
    <div class="line"></div>
    <a href="https://quantum-systems.com/legal-notice/">
      {{ 'side_nav.legal_notice' | translate }}
    </a>
    <a href="https://quantum-systems.com/terms-and-conditions/">
      {{ 'side_nav.terms_conditions' | translate }}
    </a>
    @if ((profile$ | async)?.isMasteradmin) {
      <div class="build-info">
        <div [title]="frontendBuild.commit">
          {{ 'side_nav.build_frontend' | translate }}
          {{ frontendBuild.buildVersion }}
          <span class="build-time">{{
            frontendBuild.buildTime | date: 'yyyy-MM-dd HH:mm'
          }}</span>
        </div>
        @if (backendConfig$ | async; as backendConfig) {
          <div [title]="backendConfig.buildCommit?.commitId ?? ''">
            {{ 'side_nav.build_backend' | translate }}
            @if (backendConfig.buildCommit?.shortCommitId) {
              {{ backendConfig.buildCommit?.shortCommitId }} ({{
                backendConfig.buildCommit?.branch
              }})
              @if (backendConfig.buildCommit?.commitTime) {
                <span class="build-time">{{
                  backendConfig.buildCommit?.commitTime
                    | date: 'yyyy-MM-dd HH:mm'
                }}</span>
              }
            } @else {
              {{ 'side_nav.build_unavailable' | translate }}
            }
          </div>
        }
      </div>
    }
  </div>
</div>
<div class="container-topbar">
  <div class="logo-bubble-container">
    <img
      class="logo"
      src="../assets/svg/logo-mobile.svg"
      alt="dashboard - Quantum Systems"
    />
  </div>
  <div class="avatar-bubble-container">
    <app-avatar [avatarTop]="true"></app-avatar>
  </div>
  <div class="search-bubble-container">
    <app-button
      [searchType]="true"
      [title]="'side_nav.update' | translate"
    ></app-button>
  </div>
  <div class="burger-bubble-container">
    <div
      class="burger-container"
      [ngClass]="clickOn ? 'change' : ''"
      (click)="opening()"
    >
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
      <div class="circle"></div>
    </div>
  </div>
</div>
<div
  class="menu-open"
  [ngClass]="clickOn ? 'showing' : ''"
  *ngIf="profile$ | async as profile"
>
  <ul>
    <ng-container *ngFor="let menu of menuItems">
      @if (menu.hasFeature$ | async) {
        @if (!menu.roles || menu.roles.includes(profile.role)) {
          @if (menu.children?.length) {
            <li class="mobile-group-item">
              <div
                class="mobile-group-label"
                [attr.data-testid]="'mobile-nav-item-' + menu.id"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="isMenuExpanded(menu)"
                (click)="toggleMenu(menu)"
                (keydown)="onMenuGroupKeydown($event, menu)"
              >
                <span>{{ 'side_nav.menu.' + menu.id | translate }}</span>
                <mat-icon
                  class="mobile-expand-icon"
                  [ngClass]="{ expanded: isMenuExpanded(menu) }"
                >
                  chevron_right
                </mat-icon>
              </div>
            </li>
            @if (isMenuExpanded(menu)) {
              <ng-container *ngFor="let childMenu of menu.children">
                @if (childMenu.hasFeature$ | async) {
                  @if (
                    !childMenu.roles || childMenu.roles.includes(profile.role)
                  ) {
                    <li class="mobile-child-item">
                      <a
                        [attr.data-testid]="'mobile-nav-child-' + childMenu.id"
                        [routerLink]="childMenu.link"
                        (click)="opening()"
                      >
                        {{ 'side_nav.menu.' + childMenu.id | translate }}
                      </a>
                    </li>
                  }
                }
              </ng-container>
            }
          } @else {
            <li>
              <a
                [attr.data-testid]="'mobile-nav-item-' + menu.id"
                [routerLink]="menu.link"
                (click)="opening()"
              >
                {{ 'side_nav.menu.' + menu.id | translate }}
              </a>
            </li>
          }
        }
      }
    </ng-container>
    <li>
      <a href="https://quantum-systems.com/legal-notice/">
        {{ 'side_nav.legal_notice' | translate }}
      </a>
    </li>
    <li>
      <a href="https://quantum-systems.com/terms-and-conditions/">
        {{ 'side_nav.terms_conditions' | translate }}
      </a>
    </li>
    <li (click)="childMethod()">
      <div role="button" data-testid="sidenav-logout-button">
        {{ 'side_nav.logout' | translate }}
      </div>
    </li>
  </ul>
</div>
